<div class="flex flex-row items-center gap-4">
  <!-- CNPJSelectorComponent.html -->
  <div
    class="cnpj-passo hidden md:block transition-all duration-300 border-transparent border hover:border hover:border-hs-active rounded-xl ">

    <button type="button" (click)="userService.toggleCnpjSelector()"
      class="relative flex items-center justify-end w-full h-10 min-w-10 group transition-colors">
      <!-- Container flexível para os elementos -->
      <div class="flex items-center gap-2 overflow-hidden w-full">
        <!-- Loja - move para a esquerda no hover -->
        <svg [ngClass]="!(userService.searchedCnpj) ? 'text-zinc-400' : 'text-hs-active right-auto left-3'"
          xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
          stroke="currentColor"
          class="size-6 transition-all duration-200 absolute right-0 group-hover:right-auto group-hover:left-3">
          <path stroke-linecap="round" stroke-linejoin="round"
            d="M13.5 21v-7.5a.75.75 0 0 1 .75-.75h3a.75.75 0 0 1 .75.75V21m-4.5 0H2.36m11.14 0H18m0 0h3.64m-1.39 0V9.349M3.75 21V9.349m0 0a3.001 3.001 0 0 0 3.75-.615A2.993 2.993 0 0 0 9.75 9.75c.896 0 1.7-.393 2.25-1.016a2.993 2.993 0 0 0 2.25 1.016c.896 0 1.7-.393 2.25-1.015a3.001 3.001 0 0 0 3.75.614m-16.5 0a3.004 3.004 0 0 1-.621-4.72l1.189-1.19A1.5 1.5 0 0 1 5.378 3h13.243a1.5 1.5 0 0 1 1.06.44l1.19 1.189a3 3 0 0 1-.621 4.72M6.75 18h3.75a.75.75 0 0 0 .75-.75V13.5a.75.75 0 0 0-.75-.75H6.75a.75.75 0 0 0-.75.75v3.75c0 .414.336.75.75.75Z" />
          </svg>

          <!-- Texto que aparece no hovers -->
          @if (!(userService.searchedCnpj)) {
            <span
              class="text-xs font-medium text-zinc-400 whitespace-nowrap overflow-hidden transition-all duration-200 max-w-0 group-hover:max-w-xs ml-6 group-hover:mr-6 group-hover:ml-12"
              >
              Nenhum CNPJ selecionado
            </span>
          }
          @if (userService.searchedCnpj) {
            <span
              class="text-sm font-medium text-hs-active whitespace-nowrap overflow-hidden transition-all duration-200 mr-6 ml-12"
              >
              {{ userService.searchedCnpj| formatCnpj }}
            </span>
          }

          <!-- Espaçador automático para empurrar o chevron para a direita -->
          <div class="flex-grow"></div>
        </div>

        <!-- Chevron - aparece apenas no hover -->
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="currentColor"
          class="absolute right-2 size-4 text-zinc-400 opacity-0 transition-opacity duration-200 group-hover:opacity-100 pointer-events-none">
          <path fill-rule="evenodd"
            d="M4.22 6.22a.75.75 0 0 1 1.06 0L8 8.94l2.72-2.72a.75.75 0 1 1 1.06 1.06l-3.25 3.25a.75.75 0 0 1-1.06 0L4.22 7.28a.75.75 0 0 1 0-1.06Z"
            clip-rule="evenodd" />
          </svg>
        </button>
      </div>

      <!-- Announcekit (comentado — substituído pelo sino de notificações de arquivos) -->
      <!-- <div class="px-2">
      <announcekit *ngIf="auth.user$ | async as user" [user]="{ id: user.email, user: user.email }" [lang]="'pt'"
        [widget]="announcekitWidget">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
          stroke="currentColor" class="text-gray-400 hover:text-hs-active size-6">
          <path stroke-linecap="round" stroke-linejoin="round"
            d="M14.857 17.082a23.848 23.848 0 0 0 5.454-1.31A8.967 8.967 0 0 1 18 9.75V9A6 6 0 0 0 6 9v.75a8.967 8.967 0 0 1-2.312 6.022c1.733.64 3.56 1.085 5.455 1.31m5.714 0a24.255 24.255 0 0 1-5.714 0m5.714 0a3 3 0 1 1-5.714 0" />
          </svg>
        </announcekit>
      </div> -->

      <!-- Notificações de arquivos de marketing -->
      <app-notification-bell></app-notification-bell>

      <!-- User -->
      <div>
        <div id="avatarButton" type="button" data-dropdown-toggle="userDropdown" data-dropdown-placement="bottom-end"
          class="flex flex-row gap-2 px-2 py-1 items-center rounded-lg border border-transparent group-hover:!text-hs-active hover:border-hs-active hover:text-hs-active hover:cursor-pointer hover:bg-slate-50 transition-all duration-300">
          <img class="w-7 h-7 border-2 rounded-full cursor-pointer" [src]="userService.picture" alt="User dropdown">
          @if (auth.user$ | async; as user) {
            <div class="text-sm font-medium hover:!text-hs-active text-gray-500 ">
              {{ user.name }}
            </div>
          }
        </div>

        <div id="userDropdown"
          class="hidden bg-white absolute right-0 left-auto mt-40 z-40 divide-y divide-gray-100 rounded-lg shadow w-auto max-w-80">
          <div class="px-4 py-3 text-sm text-gray-900 dark:text-white">
            @if (auth.user$ | async; as user) {
              <div>
                {{ user.name }}
              </div>
            }
            @if (auth.user$ | async; as user) {
              <div class="font-medium truncate">
                {{ user.email }}
              </div>
            }
          </div>

          <div class="py-1 hover:cursor-pointer">
            <a (click)="logout()"
              class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 dark:hover:bg-gray-600 dark:text-gray-200 dark:hover:text-white">
              Sair
            </a>
          </div>
        </div>
      </div>
    </div>